<app-toolbar></app-toolbar>
<div class="content">
  <app-todo (loadingEvent)="onLoadingEvent($event)"></app-todo>
  @if (showLoading) {
    <mat-spinner></mat-spinner>
  }
</div>
<app-footer></app-footer>
